export default {
    //日语
    DiagnosticReport:'診断レポート',
    troubleCode:'こしょうコード',
    time:'時間',
    // 语言
    lang:{
        cn:'中国語',
        de:'ドイツ語',
        en:'英語',
        es:'スペイン語',
        fr:'フランス語',
        it:'イタリア語',
        ja:'日本語',
        ko:'韓国語',
        pt:'ポルトガル語'
    }
}